// /src/i18n/LanguageContext.jsx
import React, { createContext, useContext, useEffect, useState, useMemo } from 'react';
import { translations } from './translations';

const STORAGE_KEY = 'sfarina_lang';
const SUPPORTED = ['it', 'en'];

const detectInitialLang = () => {
  if (typeof window === 'undefined') return 'it';
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved && SUPPORTED.includes(saved)) return saved;
    const nav = (navigator.language || 'it').slice(0, 2);
    return SUPPORTED.includes(nav) ? nav : 'it';
  } catch (_) {
    return 'it';
  }
};

const LanguageContext = createContext({
  lang: 'it',
  setLang: () => {},
  t: translations.it,
});

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectInitialLang);

  const setLang = (next) => {
    if (!SUPPORTED.includes(next)) return;
    setLangState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (error) {
      console.error('[Sfarinà i18n] Failed to persist language preference:', error);
    }
  };

  useEffect(() => {
    if (typeof document !== 'undefined') {
      document.documentElement.lang = lang;
    }
  }, [lang]);

  const value = useMemo(
    () => ({ lang, setLang, t: translations[lang] || translations.it }),
    [lang]
  );

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useT = () => useContext(LanguageContext);
